module.exports = __webpack_public_path__ + "img/DISCONNECTED.6632f0b8.svg";